<template>
  <div class="taoBao">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>

    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="queryList"
        v-model:inputValue="mydata.form.search"
      ></inputBox>
    </div>

    <!-- 模块2 -->
    <div class="box-online1">
      <!-- 学科筛选按钮 -->
      <subjectButton
        :filterButton="mydata.filterButton1"
        style="margin-bottom: 10px"
        @change="change1"
        :key="mydata.testKey0"
      ></subjectButton>
      <subjectButton
        :filterButton="mydata.filterButton2"
        @change="change2"
        :key="mydata.testKey1"
      ></subjectButton>
    </div>
    <!--模块3  -->
    <div class="box-online2">
      <researchProjects
        :path="mydata.online_path"
        v-for="(item, index) in mydata.articleListArr"
        :key="index"
        :info="item"
        :showBoxShadow="false"
      >
        <template #img>
          <img
            v-complete:src="item.image"
            alt=""
            width="367px"
            height="201px"
            style="cursor: pointer"
          />
        </template>
        <template #Button>
          <!-- <el-button plain>数学</el-button> -->
          <!-- <el-tag>{{ byIdGetText(item.subject, "subject") }}</el-tag> -->
          <el-tag v-if="item.class_stage_text">{{
            item.class_stage_text
          }}</el-tag>
          <el-tag v-if="item.classes_text">{{ item.classes_text }}</el-tag>
          <el-tag v-if="item.subject_text">{{ item.subject_text }}</el-tag>
          <el-tag v-for="(item, index) in item.tags" :key="index">{{
            item.name
          }}</el-tag>
        </template>
      </researchProjects>

      <!-- 空白内容组件 -->
      <glEmpty
        v-if="mydata.articleListArr.length === 0"
        marginBottom="20px"
      ></glEmpty>
    </div>
    <!--分页 -->
    <div class="gl-pagination">
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// 是否来自其他模块
let fromOtherModule = false;
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "onlineLearning",
  beforeRouteEnter(to, from, next) {
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (from.path !== "/layout/list/onlineDetails") {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>




<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";
import subjectButton from "@/components/subjectButton/index.vue";
import bookBigListenCards from "@/components/bookBigListenCards/index.vue";

import researchProjects from "@/components/researchProjects/index.vue";

// 引入文章列表接口
import {
  articleList,
  onlineStudyClass,
  onlineStudyCondition,
} from "@/api/home/index.js";

// 引入接口
import { getUrlId } from "@/utils/slide.js";

import { reactive, onActivated } from "vue";

import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  // currentPage3: "5",
  // pageSize3: "100",
  // small: false,
  // background: false,
  // disabled: false,

  //筛选按钮
  filterButton1: {
    title: "年级",
    filter: [],
    // filter: JSON.parse(localStorage.getItem("classes2")) ?? [],
    // filter: ["全部", "初一", "初二", "初三", "中考", "高一", "高二", "高三"],
  },
  filterButton2: {
    title: "学科",
    filter: [],
    // filter: JSON.parse(localStorage.getItem("subject")) ?? [],
    // filter: ["全部", "语文", "数学", "英语", "马克思", "历史"],
  },

  testKey0: new Date().getTime() - Math.random() * 10,
  testKey1: new Date().getTime() - Math.random() * 100,

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  online_path: "/layout/list/onlineDetails",
  articleListArr: [], // 文章列表

  classArr: [], // 班级
  subjectArr: [], //学科

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 9, // 每页条数
    total: 0, // 总的条数
  },
  form: {
    column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询
    classes: "", //班级（年级）
    subject: "", //学科
  },

  subject: JSON.parse(localStorage.getItem("subject")) ?? [], //标签
});

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    //筛选按钮
    mydata.filterButton1 = {
      title: "年级",
      filter: [],
    };
    mydata.filterButton2 = {
      title: "学科",
      filter: [],
    };

    mydata.testKey0 = new Date().getTime() - Math.random() * 10;
    mydata.testKey1 = new Date().getTime() - Math.random() * 100;

    // 基础地址
    mydata.VUE_APP_BASE_HOST = process.env.VUE_APP_BASE_HOST;
    mydata.online_path = "/layout/list/onlineDetails";
    mydata.articleListArr = []; // 文章列表

    mydata.classArr = []; // 班级
    mydata.subjectArr = []; //学科

    mydata.pageObj = {
      currentPage: 1, // 当前页数
      pageSize: 9, // 每页条数
      total: 0, // 总的条数
    };
    mydata.form = {
      column_id: getUrlId(route.path), // 栏目id值
      search: "", // 搜索查询
      classes: "", //班级（年级）
      subject: "", //学科
    };

    mydata.subject = JSON.parse(localStorage.getItem("subject")) ?? []; //标签

    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    articleListFn();
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getSearchOptions();
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  if (localStorage.getItem("v") !== null) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1;
    mydata.form.search = localStorage.getItem("v"); // 获取本地存储并且赋值
    localStorage.removeItem("v"); // 赋值后立刻删除本地存储内容
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    articleListFn();
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getSearchOptions();
    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    // router.push({
    //   path:"/layout/list/addedServices"
    // })
  }
});

// 通过ID得到对应文字————标签
function byIdGetText(id, key) {
  return mydata[key].find((item) => String(item.name) === String(id))?.label;
}

function getSearchOptions() {
  onlineStudyCondition().then((res) => {
    // console.log(1, res.data.classes);
    // console.log(2, res.data.subject);
    let obj1 = res.data.classes;
    let arr1 = [];
    for (const key in obj1) {
      if (Object.prototype.hasOwnProperty.call(obj1, key)) {
        const item = {
          name: Number(key),
          label: obj1[key],
        };
        arr1.push(item);
      }
    }
    mydata.filterButton1.filter = arr1;
    //////////////////////////////////////////
    let obj2 = res.data.subject;
    let arr2 = [];
    for (const key in obj2) {
      if (Object.prototype.hasOwnProperty.call(obj2, key)) {
        const item = {
          name: Number(key),
          label: obj2[key],
        };
        arr2.push(item);
      }
    }
    mydata.filterButton2.filter = arr2;
  });
}

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  articleListFn();
}

////////////////////获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
    // console.log(res.data.list, "在线学习页面");
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 查询列表
function queryList(dict, inputValue) {
  // 分页变成第一页
  mydata.pageObj.currentPage = 1;
  // 赋值
  mydata.form.search = inputValue;
  // 查询
  articleListFn();
}

// 查询
// articleListFn();

// 年级单选框改变事件
function change1(val) {
  // 赋值
  mydata.form.classes = val;
  // 查询
  articleListFn();
}

// 学科单选框改变事件
function change2(val) {
  mydata.form.subject = val;
  // 查询
  articleListFn();
}

//点击事件
// function detailsTwoButton() {
//   router.push({
//     path: "/layout/list/detailsTwo",
//   });
// }
</script>

<style scoped lang="scss">
.taoBao {
  background-color: #f9f9f9;
  // padding-bottom: 40px;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
    }
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
  }

  //////模块2------搜索组件 和 按钮组件
  .box-online1 {
    background-color: #ffffff;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 16px;
    padding: 16px 0px;
    overflow: hidden;
  }
  ///////模块3
  .box-online2 {
    // width: 1200px;
    // height: 1352px;
    margin: 0 auto;
    background-color: #ffffff;
    // border: 1px solid rgb(0, 255, 13);
    // padding: 30px;
    // border-radius: 10px;
    // display: flex;
    // justify-content: flex-start;
    // flex-wrap: wrap;
    // flex-shrink: 0;
    margin-top: 20px;
    padding:16px;
    // padding: 30px 30px 0px 30px;

    .box-project {
      border-top: 1px solid rgba(114, 114, 115, 0.306);

      padding-top: 16px;
      padding-bottom: 11px;
      // margin-bottom:16px;
      border-radius: 0px;
      // box-shadow: 2px 3px 3px #f6f4f4;
      box-shadow: none;
      img {
        width: 343px !important;
        height: 201;
        display: block;
        border-radius: 8px;
      }
      > p {
        margin-top: 10px;
        margin-left: 0px;
        margin-right: 0px;
      }
      :deep(.box-p){
        margin:16px 0px !important;
      }
      .el-tag {
        background: #f0f5ff;
        color: #333333;
        font-size: 12px;
        border: 1px solid #c5cbce;
        // margin-top: -16px;
        margin-left: 0px;
        padding: 3px 8px 3px 8px;
        height: 26px;
        // border:1px solid red;
        margin-right: 5px;
        margin-bottom: 5px;
      }
    }
    .box-project:first-of-type{
      padding-top:0px;
      border-top:none;
    }

    .box-project:last-of-type {
      padding-bottom: 0px;
    }
  }
  //////模块4————分页
  .paging {
    // margin: 0 auto;
    margin-top: 40px;
    // margin-bottom: 40px;
    display: flex;
    justify-content: center;
    // border:1px solid red;

    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
</style>
